import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BUSINESS } from "@/config";

const CANONICAL_ORIGIN = "https://maisonneufny.com";

function setCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export function useSEO({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    const path = pathname === "/" ? "" : pathname;
    setCanonical(`${CANONICAL_ORIGIN}${path}`);
  }, [title, description, pathname]);
}

export default function SEO({ title, description }) {
  useSEO({
    title: title ? `${title} | ${BUSINESS.name}` : BUSINESS.fullName,
    description,
  });
  return null;
}
